import api from "../Utils/axios";
import { adminV1Base } from "../Utils/connection_strings";

export const getNotificationTemplates = (
  page,
  perPage,
  search_string,
  status
) => {
  const payload = {
    page,
    limit: Number(perPage) || 10,
  };

  if (search_string) payload.search = search_string;
  if (status) payload.status = status;

  return api.post(`${adminV1Base}/notification/template/get`, payload);
};

export const getNotificationTemplateById = (id) => {
  return api.post(`${adminV1Base}/notification/template/get-by-id`, { id });
};

export const editNotificationTemplate = (data) => {
  return api.post(`${adminV1Base}/notification/template/edit`, data);
};
